module.exports = __webpack_public_path__ + "img/dell.2acb4039.svg";